// @flow

import type { ComparableKpi, KPIs } from '../types/geminiType';
import { occupancyCost, salesR12m } from '../pages/mall/map/gemini/geminiConst';
import { computeOcupancyCost } from '../pages/mall/map/gemini/geminiFunctions';

function computeAvg(
  kpiArr: ComparableKpi[],
  kpiParam: string,
  filteredStores?: number[],
  isWithoutSst?: boolean,
): { value: number, gla: number } {
  if (!kpiArr) {
    return { value: null, gla: null };
  }
  const arr = kpiArr.filter((kpi: ComparableKpi) =>
    !(filteredStores && filteredStores.includes(kpi.codstr))
    && (kpi[kpiParam] || kpiParam === occupancyCost));

  let res;
  if (kpiParam === occupancyCost) {
    res = arr.reduce((acc: number, kpi: KPIs) => (acc + computeOcupancyCost(kpi)), 0);
  } else {
    res = arr.reduce((acc: number, kpi: KPIs) => (acc + kpi[kpiParam]), 0);
  }
  const avgGla = computeAvgGla(arr, kpiParam, isWithoutSst);
  return { value: res / arr.length, gla: avgGla };
}

function computeAvgGla(kpiArr: ComparableKpi[], kpiParam: string, isWithoutSst?: boolean) {
  let count = 0;
  let all = 0;
  kpiArr.forEach((kpiArrItem: ComparableKpi) => {
    let gla = kpiArrItem.glaWithSst;
    if (kpiParam === salesR12m) {
      gla = isWithoutSst ? kpiArrItem.glaWithoutSst : kpiArrItem.glaDen;
    }
    if (gla) {
      all += gla;
      count += 1;
    }
  });
  if (count === 0) {
    return 0;
  }
  return all / count;
}

export default computeAvg;
